'use client';

import Spinner from '@/assets/images/spinner.svg';
import clsx from 'clsx';
import React from 'react';

export type LoadingSpinnerCenter = 'full-screen' | 'within-page' | 'within-full' | 'within';

type LoadingSpinnerComponentProps = {
  center?: LoadingSpinnerCenter;
  className?: string;
};

export const LoadingSpinnerComponent = ({ center, className }: LoadingSpinnerComponentProps): React.JSX.Element => {
  const spinnerElement =
    <Spinner className="w-[48px] h-[48px] text-gray-200 animate-spin dark:text-gray-600 fill-primary" />
  ;

  if (center === 'within') {
    return <div className={clsx('grid place-items-center', className)}>{spinnerElement}</div>;
  }

  if (center === 'within-full') {
    return (
      <div className={clsx('grid place-items-center w-full h-full', className)}>
        {spinnerElement}
      </div>
    );
  }

  if (center === 'within-page') {
    return (
      <div className={clsx('grid place-items-center w-full h-full my-12', className)}>
        {spinnerElement}
      </div>
    );
  }

  return (
    <div className={clsx('fixed inset-0 z-300 flex items-center justify-center bg-white/80 dark:bg-black/40', className)}>
      {spinnerElement}
    </div>
  );
};
